exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".locationPanel{\r\n  margin-top: 20px;\r\n  width: 255px;\r\n  margin-left: 5%;\r\n  background-color: white;\r\n  box-shadow: 2px 2px 15px 2px;\r\n}\r\n.panel-heading{\r\n  color: #333;\r\n  background-color: #f5f5f500;\r\n  border-color: aqua;\r\n}\r\n.locationButtons{\r\n  margin-right: 30px;\r\n  background-color: transparent;\r\n}\r\n.locationButtons:hover{\r\n  border-color: darkgray;\r\n  color: darkgray;\r\n}\r\n.addPanel{\r\n  margin-left: 80%;\r\n  width: 200px;\r\n  background-color: transparent;\r\n  border-color: transparent;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/pkwoy/Desktop/progressive-webb-app/src/app/location-view/location-view.component.css
// module id = ../../../../../src/app/location-view/location-view.component.css
// module chunks = main